// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1YLxz","itemTitle":"ClientEmergencyInfo_itemTitle__2T7Kr","itemText":"ClientEmergencyInfo_itemText__1lFbm"};